export default {
  tiles: [
    {
      index: 1,
      backgroundColor: '#005FB9',
      textColor: 'white',
      entityName: 'travel_rewards_smorg',
      eyebrow: 'Smart travel moves',
      eyebrowColor: 'white',
      description:
        'Earn travel rewards now for that trip you know you’ll want to take later',
      buttonText: 'Point the way',
      buttonUrl:
        'https://www.nerdwallet.com/article/travel/why-you-should-get-your-new-travel-card-6-months-ahead-of-your-trip?trk=hp_smorg_travel_hub&trk_copy=hp_smorg_travel_rewards',
    },
    {
      index: 2,
      backgroundColor: '#E3FAF2',
      entityName: 'socially_responsible_investing_smorg',
      eyebrow: 'Make an impact',
      eyebrowColor: 'neutral-darker',
      description:
        'Learn how to invest in Black-owned businesses and green companies.',
      buttonText: 'Show me more',
      buttonUrl:
        'https://www.nerdwallet.com/article/investing/socially-responsible-investing?trk=hp_smorg_socially_responsible_investing&trk_copy=hp_smorg_socially_responsible_investing',
    },
    {
      index: 3,
      backgroundColor: '#E3FAF2',
      entityName: 'manage_credit_score_smorg',
      eyebrow: 'Moving on up',
      eyebrowColor: 'neutral-darker',
      description: 'Build your credit with this simple recipe.',
      buttonText: 'Yes please',
      buttonUrl:
        'https://www.nerdwallet.com/article/finance/simple-way-manage-credit-score?trk=hp_smorg_manage_credit_score&trk_copy=hp_smorg_manage_credit_score',
    },
    {
      index: 4,
      backgroundColor: '#F5F5F5',
      entityName: 'podcast_guide_smorg',
      eyebrow: 'Worth A Listen',
      eyebrowColor: 'neutral-darker',
      description:
        'Have a money goal? Turn to our SmartMoney podcast for hacks, how-tos and more.',
      buttonText: 'Tune in',
      buttonUrl:
        'https://www.nerdwallet.com/blog/podcast/?trk=hp_smorg_smartmoneypodcast&trk_copy=hpsmartmoneypodcast',
    },
    {
      index: 5,
      backgroundColor: '#EEF7FF',
      entityName: 'pay_per_mile_car_insurance_smorg',
      eyebrow: 'Start saving',
      eyebrowColor: 'neutral-darker',
      description:
        "Working from home? Here's how to spend less on car insurance.",
      buttonText: 'Get answers',
      buttonUrl:
        'https://www.nerdwallet.com/article/insurance/pay-per-mile-car-insurance?trk=hp_smorg_car_insurance&trk_copy=hp_smorg_car_insurance',
    },
    {
      index: 6,
      backgroundColor: '#E3FAF2',
      textColor: 'neutral-darkest',
      entityName: 'banking_guide_smorg',
      eyebrow: 'How interesting...',
      eyebrowColor: 'neutral-darker',
      description: 'Discover banks that pay the highest interest rates on CDs.',
      descriptionImage: '',
      descriptionItalic: '',
      buttonText: 'Yay free money',
      buttonUrl:
        'https://www.nerdwallet.com/best/banking/cd-rates?trk=hp_smorg_bestcds&trk_copy=hpbestcds',
    },
  ],
};
